import React, { useState, useEffect } from "react";
import PWelcome from "./Assessts/Images/PrincipleWelcome.png";
import Ptrends from "../Student/Assests/Images/Ptrends.png";
import LookAnswer from "../Student/Assests/Images/LookAnswer.png";
import Practice from "../Student/Assests/Images/Practice.png";
import TeacherCard from "./Assessts/Images/Teacher-card.png";
import ReportCard from "./Assessts/Images/Report-Card.png";
import Analyze from "../Student/Assests/Images/Analyze.png";
import Assessment from "../Student/Assests/Images/Assessment.png";
import InternetChecking from "../Student/Reusablecomponents/Network";
import CopyRight from "../Student/Reusablecomponents/Copyright";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import WithTranslate from "../ReusableComponents/StaticTranslater/Translater";
import axiosInstance from "../ReusableComponents/Axios";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { YearDD } from "../ReusableComponents/CommonApis";
const PrincipleDashboard = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const [ASSDates, SetASSDates] = useState([]);
  const [Notice, SetNotice] = useState();
  const [OpenPT, SetOpenPT] = useState(false);

  useEffect(() => {
    // GetNotice();
    getdates();
  }, [USYear]);
  const getdates = async () => {
    try {
      const res = await axiosInstance.get(
        `/Principal/GetAssessmentTypesAndDatesByInstitute?Year=${USYear?.value}&InstituteId=${items?.instituteId}&UserId=${items?.userId}&SocietyId=${items?.societyId || 0}`
      );
      const filter = res.data.filter((item) => item?.assessmentType === 3)
      SetASSDates(filter);
    }
    catch (err) {
      console.log(err)
    }
  }
  const PReport = (e) => {
    switch (e) {
      case 0:
        navigate("/PrinciplePerformance");
        break;
      case 1:
        navigate("/PrincipleParticipation");
        break;
      case 2:
        navigate("/TeacherDashboard/StudentInformation/StudentDetails");
        break;
      case 3:
        navigate("/TeacherDashboard/StudentInformation/AutobulkRegistrations");
        break;
      case 4:
        navigate(
          "/TeacherDashboard/StudentInformation/Results/AssessmentResults",
        );
        break;
      case 5:
        navigate("/Principle/PrincipleAnswerSheetDetails");
        break;
      case 6:
        navigate("/Principle/PrincipleReportCard");
        break;
      case 7:
        if (ASSDates?.length <= 0) return;
        navigate("/Principle/SamagraDashboard");
        break;
      default:
        navigate("/PrincipleDashboard");
        break;
    }
  };

  const Cards = [
    { CardName: "Performance", image: Ptrends, Description: "Access sodhana Performance data", },
    { CardName: "Participation", image: LookAnswer, Description: "Track Participation details", },
    { CardName: "Registrations", image: Assessment, Description: "Download all grades student logins", },
    { CardName: "Bulk Registrations", image: Practice, Description: "Bulk Register Students", },
    { CardName: "Results", image: Analyze, Description: "View assessment results", },
    { CardName: "Teachers", image: TeacherCard, Description: "Download assessment question papers. Download report cards", },
    { CardName: "Report Cards", image: ReportCard, Description: "View the report cards for the assessments", },
    { CardName: "Samagra Reports", image: ReportCard, Description: "", },
    // ...(ASSDates?.length > 0  ? [ { CardName: "Samagra Reports", image: ReportCard, Description: "", }, ] : []),
  ];
  // Below is for notice
  const GetNotice = async () => {
    try {
      const response = await axiosInstance.get(
        `/Assessment/GetLatestAssessmentDetails?UserId=${items.userId}`,
      );
      if (response.data[0].examAvailabilityStartDate) {
        SetNotice(response.data);
      } else {
        SetNotice();
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <div className="Dashboard-Maindiv Instructions-pages">
        <InternetChecking />
        <div className="PrincipleWelcome dflex alignitems mb-5">
          <img src={PWelcome} alt="Welcome image" />
          <div className="DHeading">
            {/* <span>{items?.fullName}</span> Welcome-Details*/}
            <h3>
              {" "}
              <span style={{ textTransform: "capitalize" }}>
                Welcome, Admin
              </span>{" "}
              <WithTranslate name="Dashboard.Question" />{" "}
            </h3>
          </div>
        </div>

        <div>
          <div className="dflex alignitems JSBetween DHeading">
            {/* <div onClick={() => SetOpenPT(!OpenPT)}>Help </div>*/}
          </div>

          <div className="Udetails dflex">
            <div className="dflex PrincipleCards">
              {Cards.map((Card, index) => (
                <div onClick={() => { PReport(index); }}  title={Card.CardName === "Samagra Reports" && ASSDates?.length <= 0 && "No SAMAGRA Assessments scheduled."}
                  className={`dflex flexd-column ${(Card.CardName === "Samagra Reports" && ASSDates?.length <= 0) ? "DisableTest" : ""}`}  >
                  {Card.CardName}
                  <span> {Card.Description}</span>
                  <img src={Card.image} alt="Cards" />
                </div>
              ))}
            </div>

            <div className="Notice">
              <h5>Notice</h5>
              <div>
                <b>Assessment Schedule</b>
                <br />
                {Notice ? (
                  <ol>
                    {Notice?.map((item) => (
                      <li className="mb-3">
                        Upcoming {item.assessmentTypeNo} assessment schedule on{" "}
                        {item.examAvailabilityStartDate} to{" "}
                        {item.examAvailabilityEndDate}
                      </li>
                    ))}
                  </ol>
                ) : (
                  "No Assessments are available"
                )}
              </div>
            </div>
          </div>
          <CopyRight />
        </div>

        {OpenPT && (
          <div className=" Model-Open">
            <div className="Card w-100 h-100">
              <div className="dflex JSBetween">
                <div></div>
                <div className="CPointer fs-4">
                  <IoMdCloseCircleOutline onClick={() => SetOpenPT(!OpenPT)} />
                </div>
              </div>
              <iframe src="/Portal Tutorial.pdf" width="100%" height="95%"  title="PDF Viewer" ></iframe>
            </div>
          </div>
        )}
      </div>
      <div style={{ display: "none" }}><YearDD /></div>
    </>
  );
};
export default PrincipleDashboard;
